import { createSelector } from "@reduxjs/toolkit";
import {
  DESCRIPTION_EN,
  DESCRIPTION_SP,
  LOCALE_EN,
  UI_OPTIONS,
} from "../Constants/CommonConstants";
import { manageLocaleSelector } from "./LocaleSelector";

const formattedLocaleOptions = (state, label) => {
  const { language } = manageLocaleSelector(state);
  return state.referenceData?.referenceOptions[label]?.map((item) => ({
    value: item.value,
    label: language === LOCALE_EN ? item.displayEn : item.displayEs,
  }));
};

const selectReferenceDataStatus = (state) => state.referenceData?.status;

const selectCommonYesNo = (state) => {
  return formattedLocaleOptions(state, UI_OPTIONS);
};

const selectSexDropdownValues = (state) => {
  return state.referenceData?.referenceOptions.sexDropdownOptions;
};

const selectUserRole = (state) => {
  return state.referenceData?.referenceOptions.userRole;
};

const selectPreferredLanguage = (state) => {
  return state.referenceData?.referenceOptions?.preferredLanguage;
};

const getEmailLanguage = (state, description) => {
  return state.referenceData?.referenceOptions.preferredLanguage.find(
    (lang) => lang.description === description
  );
};

const selectEnglishEmailLanguage = (state) => {
  return getEmailLanguage(state, DESCRIPTION_EN);
};

const selectSpanishEmailLanguage = (state) => {
  return getEmailLanguage(state, DESCRIPTION_SP);
};

export const manageReferenceDataSelector = createSelector(
  [
    selectReferenceDataStatus,
    selectCommonYesNo,
    selectSexDropdownValues,
    selectUserRole,
    selectPreferredLanguage,
    selectEnglishEmailLanguage,
    selectSpanishEmailLanguage,
  ],
  (
    referenceDataStatus,
    commonYesNo,
    sexDropdownValues,
    userRole,
    preferredLanguage,
    englishEmailLanguage,
    spanishEmailLanguage
  ) => ({
    referenceDataStatus,
    commonYesNo,
    sexDropdownValues,
    userRole,
    preferredLanguage,
    englishEmailLanguage,
    spanishEmailLanguage,
  })
);
